


















export default {
  props: {
    multiStop: { type: Object, required: true },
    hasLabel: { type: Boolean, default: true },
    isDialogMode: { type: Boolean, default: false }
  },
  computed: {
    hasIntermediateStops() {
      return this.multiStop.intermediateStops > 0
    },
    showIntermediateStops() {
      const pluralized = this.$tc(
        'marketPlace.order.multiStops',
        this.multiStop.intermediateStops
      )
      return `+ ${this.multiStop.intermediateStops} ${pluralized}`
    }
  }
}
